module.exports = __webpack_public_path__ + "img/overview_build7.5c371242.png";